import { useQuery } from '@tanstack/react-query';
import { useTypedOpenApi } from '../../providers';
import { getTimezones } from '../timezones/timezonesApi';
import { TIMEZONE_PLACEHOLDER_DATA } from '../timezones/timezonesPlaceholder';

export const TIMEZONES_QUERY_KEY = ['timezones'];

/**
 * The zone list, from `GET /timezones`.
 *
 * Never stale: the table changes when the tz database does, which is a handful of times a year, so
 * refetching it while the user is picking one buys nothing. The bundled list stands in until the
 * request answers, so the picker is searchable on the first frame and on a device with no
 * connection.
 */
export const useTimezones = () => {
  const { apiClient } = useTypedOpenApi();

  return useQuery({
    queryKey: TIMEZONES_QUERY_KEY,
    queryFn: () => getTimezones(apiClient),
    staleTime: Number.POSITIVE_INFINITY,
    placeholderData: TIMEZONE_PLACEHOLDER_DATA,
  });
};
